export function validateSource(input) {
    switch (input) {
        case "login":
            return true;
        case "logout":
            return true;
        case "create":
            return true;
        case "authorize":
            return true;
        default:
            return false;
    }
}
export function parseSourceAsToMode(input) {
    switch (input) {
        case "login":
            return "LOGIN";
        case "create":
            return "CREATE";
        case "authorize":
            return "LOGIN";
        default:
            return "NONE";
    }
}
export function parseSource(input) {
    switch (input) {
        case "login":
        case "logout":
        case "create":
        case "authorize":
            return input;
        default:
            throw new Error("Invalid source");
    }
}
export function parsSearchQuery(url, keys) {
    const params = {};
    for (const key of keys) {
        const value = url.searchParams.get(key);
        if (!value) {
            throw new Error("No key found in search query");
        }
        params[key] = value;
    }
    return params;
}
export function nullToUndefined(input) {
    return input === null ? undefined : input;
}
